var _mask, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRoom = function SvgRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "room_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.857,
    height: 18.857,
    x: 2.571,
    y: 2.571,
    rx: 0.857
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18.857,
    height: 18.857,
    x: 2.571,
    y: 2.571,
    stroke: "currentColor",
    strokeWidth: 2,
    mask: "url(#room_svg__a)",
    rx: 0.857
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M15.429 2.571v18.857m-.001-12.857H2.571m18.858 6.858h-6"
  })));
};
export default SvgRoom;